export default __webpack_public_path__ + "static/media/Olivia_9781846164613.34a2cf69.jpg";